import { ADMIN_URL } from '../constants/constants';

const routes = [
  { name: 'Projects', link: `/${ADMIN_URL}/projects/` },
  { name: 'Employees', link: `/${ADMIN_URL}/employees/` },
  { name: 'Reporting', link: `/${ADMIN_URL}/reporting/` },
];

export { routes };
